import * as React from 'react';
import styled from 'styled-components';
import Axios from 'axios';
import $ from 'jquery';
import {
  AuthContextType,
  ListingLabelContextType,
  ListingLabelContextProvider,
} from 'contexts';
import errorReporter from '@app/errorReporter';
import { Badge } from 'components';
import { UserLicenseType } from '@bb/users';
import { Country } from '@bb/domain/dist/types';
import SelectListingComponent from './SelectListingComponent';
import ListingComponent from './ListingComponent';

type Listing = any;

interface State {
  listingsOld?: Listing[];
  listingsNew?: Listing[];
  oldListing?: Listing;
  newListing?: Listing;
  loading?: boolean;
  combine?: boolean;
  shouldCombine?: boolean;
  appointmentConfig: boolean;
  listingContacts: boolean;
  allAppointments: boolean;
  registeredOffers: boolean;
  listingDocuments: boolean;
  deleteOldListing: boolean;
}

type MergeListingProps = any & {
  $rootScope: {
    hasFeature: AuthContextType['hasFeature'];
    isFromCountry: (country: Country) => boolean;
    labelOverrideMap: ListingLabelContextType['labelOverrideMap'];
  };
};

class MergeListing extends React.Component<MergeListingProps, State> {
  state: State = {
    appointmentConfig: false,
    listingContacts: false,
    allAppointments: false,
    registeredOffers: false,
    deleteOldListing: false,
    listingDocuments: false,
    combine: false,
  };

  constructor(props: MergeListingProps) {
    super(props);
    const {
      $rootScope: { auth, hasFeature },
      $window,
      $routeParams,
    } = props;

    if (
      auth &&
      auth.roles[auth.role] < auth.roles.TEAM_ADMIN &&
      !(auth.licenseType === UserLicenseType.LICENSED && !auth.isUnverified)
    ) {
      $window.location.replace('#/feature-missing');
    }

    const promises = [];

    if ($routeParams.from) {
      promises.push(Axios.get(`/listing/${$routeParams.from}`));
    }
    if ($routeParams.to) {
      promises.push(Axios.get(`/listing/${$routeParams.to}`));
    }
    if ($routeParams.combine) {
      this.state.combine = true;
      this.state.shouldCombine = true;
    }

    Promise.all(promises).then(responses => {
      if (responses.length > 1) {
        const [{ data: oldListing }, { data: newListing }] = responses;
        this.setState({ ...this.state, oldListing, newListing });
        this.checkCombine();
      } else if (responses.length === 1) {
        const [{ data: oldListing }] = responses;
        this.setState({ ...this.state, oldListing });
      }
    });
  }

  handleChecked = (prop: string) => (event: React.ChangeEvent<any>) => {
    this.setState({ ...this.state, [prop]: event.target.checked });
  };

  mergeDetails = () => {
    const { $window } = this.props;
    const {
      shouldCombine,
      oldListing,
      newListing,
      appointmentConfig,
      listingContacts,
      allAppointments,
      registeredOffers,
      listingDocuments,
      deleteOldListing,
    } = this.state;
    const options = {
      appointmentConfig,
      listingContacts,
      allAppointments,
      registeredOffers,
      listingDocuments,
      deleteOldListing,
    };
    this.setState({ loading: true });
    Axios.post(
      `/${shouldCombine ? 'combine' : 'merge'}/${oldListing.id}/${
        newListing.id
      }`,
      options,
      { withCredentials: true },
    )
      .then(({ data }) => {
        $('#mergeModal').on('hidden.bs.modal', () => {
          $window.location.hash = `/listing/${data.listingId}/view`;
        });
        // @ts-expect-error
        $('#mergeModal').modal('hide');
      })
      .catch(err => {
        errorReporter.error(err);
        this.setState({ loading: false });
      });
  };

  checkCombine() {
    const {
      $routeParams: { combine },
    } = this.props;
    if (combine) {
      this.setState({ shouldCombine: true });
      return;
    }
    const { oldListing, newListing } = this.state;
    if (!oldListing || !newListing) return;
    this.setState({ loading: true });

    Axios.get(`/merge/shouldcombine/${oldListing.id}/${newListing.id}`, {
      withCredentials: true,
    })
      .then(({ data }) => {
        if (data.shouldCombine) {
          this.setState({ shouldCombine: true });
        }
        this.setState({ loading: false });
      })
      .catch(e => {
        errorReporter.error(e);
        this.setState({ loading: false });
      });
  }

  render() {
    const { $rootScope, $compile, $window } = this.props;
    const {
      loading,
      combine,
      shouldCombine,
      oldListing,
      newListing,
      appointmentConfig,
      listingContacts,
      registeredOffers,
      allAppointments,
      listingDocuments,
      deleteOldListing,
    } = this.state;
    const ready = oldListing && newListing;
    const canCombine =
      ready && oldListing.mls_numbers && newListing.mls_numbers;
    let modalClass;
    if (shouldCombine) {
      if (canCombine) {
        modalClass = 'hmodal-info';
      } else {
        modalClass = 'hmodal-danger';
      }
    } else {
      modalClass = 'hmodal-success';
    }

    return (
      <ListingLabelContextProvider
        onboardingPortalId={$rootScope.auth.org.onboardingPortalId}
      >
        <div>
          <div className="normalheader transition animated fadeIn">
            <div className="hpanel">
              <div className="panel-body">
                <h2 className="font-light">
                  {shouldCombine ? 'Combine' : 'Merge'} Listings
                  {ready && !loading && (
                    <button
                      className={`btn ${
                        shouldCombine ? 'btn-info' : 'btn-success'
                      } pull-right`}
                      data-toggle="modal"
                      data-target="#mergeModal"
                      data-cy="merge-submit"
                    >
                      {shouldCombine ? 'Combine' : 'Merge'}
                    </button>
                  )}
                </h2>
              </div>
            </div>
          </div>
          <div className="content animate-panel">
            <div className="row">
              <div className="col-md-6" style={{ paddingRight: 2.5 }}>
                <div className="hpanel">
                  <div className="panel-body">
                    {oldListing ? (
                      <div className="div">
                        <h3>Step 1 - Select OLD Listing</h3>
                        <hr />
                        <ListingComponent
                          $rootScope={$rootScope}
                          $compile={$compile}
                          listing={oldListing}
                          cancel={() => {
                            $window.history.pushState(
                              null,
                              null,
                              combine
                                ? `#/listing/merge?combine`
                                : `#/listing/merge`,
                            );
                            this.setState({
                              ...this.state,
                              oldListing: null,
                              newListing: null,
                            });
                          }}
                        />
                      </div>
                    ) : (
                      <SelectListingComponent
                        headerText="Step 1 - Select OLD Listing"
                        onListingSelected={listing => {
                          $window.history.pushState(
                            null,
                            null,
                            combine
                              ? `#/listing/merge?combine&from=${listing.id}`
                              : `#/listing/merge?from=${listing.id}`,
                          );
                          this.setState({ ...this.state, oldListing: listing });
                        }}
                        isFromCountry={$rootScope.isFromCountry}
                        labelOverrideMap={$rootScope.labelOverrideMap}
                        role={$rootScope.auth?.role}
                      />
                    )}
                  </div>
                </div>
              </div>
              {oldListing && (
                <div className="col-md-6" style={{ paddingLeft: 2.5 }}>
                  <div className="hpanel">
                    <div className="panel-body">
                      {newListing ? (
                        <div>
                          <h3>Step 2 - Select NEW Listing</h3>
                          <hr />
                          <ListingComponent
                            $rootScope={$rootScope}
                            $compile={$compile}
                            listing={newListing}
                            cancel={() => {
                              $window.history.pushState(
                                null,
                                null,
                                combine
                                  ? `#/listing/merge?combine&from=${oldListing.id}`
                                  : `#/listing/merge?from=${oldListing.id}`,
                              );
                              this.setState({
                                ...this.state,
                                newListing: null,
                                shouldCombine: combine,
                              });
                            }}
                          />
                        </div>
                      ) : (
                        <SelectListingComponent
                          headerText="Step 2 - Select NEW Listing"
                          selected={oldListing.id}
                          onListingSelected={listing => {
                            $window.history.pushState(
                              null,
                              null,
                              combine
                                ? `#/listing/merge?combine&from=${oldListing.id}&to=${listing.id}`
                                : `#/listing/merge?from=${oldListing.id}&to=${listing.id}`,
                            );
                            this.setState(
                              {
                                ...this.state,
                                newListing: listing,
                                shouldCombine: combine,
                              },
                              () => {
                                this.checkCombine();
                              },
                            );
                          }}
                          isFromCountry={$rootScope.isFromCountry}
                          labelOverrideMap={$rootScope.labelOverrideMap}
                          role={$rootScope.auth?.role}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={`modal fade ${modalClass}`}
            id="mergeModal"
            tabIndex={-1}
            role="dialog"
            aria-hidden="true"
          >
            <div
              className="modal-dialog"
              style={{ width: 500, marginTop: 150 }}
            >
              <div className="modal-content">
                {ready && !loading && (
                  <div>
                    <div className="color-line" />
                    <div className="modal-header text-center">
                      <h4 className="modal-title">
                        {shouldCombine
                          ? 'Combine Listings'
                          : 'Merge Listing Details'}
                      </h4>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                          {shouldCombine && canCombine && (
                            <div>
                              Would you like to combine these 2 listings to
                              become one listing?
                              <br />
                              <br />
                              Please note: showing configuration, feedback
                              settings, and offer settings from the OLD listing
                              will be applied to the newly combined listing.
                            </div>
                          )}
                          {shouldCombine && !canCombine && (
                            <div>
                              Cannot combine listings without MLS numbers.
                            </div>
                          )}
                          {!shouldCombine && (
                            <div>
                              <div className="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={appointmentConfig}
                                    onChange={this.handleChecked(
                                      'appointmentConfig',
                                    )}
                                    data-cy="merge-appt-config"
                                  />{' '}
                                  Appointment Configuration Settings
                                </label>
                              </div>
                              <div className="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={listingContacts}
                                    onChange={this.handleChecked(
                                      'listingContacts',
                                    )}
                                    data-cy="merge-listing-contacts"
                                  />{' '}
                                  Listing Contacts
                                </label>
                              </div>
                              <div className="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={allAppointments}
                                    onChange={this.handleChecked(
                                      'allAppointments',
                                    )}
                                    data-cy="merge-appointments"
                                  />{' '}
                                  Appointments / Feedbacks/ Virtual Tours
                                </label>
                              </div>
                              <div className="checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={registeredOffers}
                                    onChange={this.handleChecked(
                                      'registeredOffers',
                                    )}
                                    data-cy="merge-offers"
                                  />{' '}
                                  Registered Offers
                                </label>
                              </div>
                              {$rootScope.hasFeature('CREATE_LISTING') && (
                                <div className="checkbox">
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={listingDocuments}
                                      onChange={this.handleChecked(
                                        'listingDocuments',
                                      )}
                                      data-cy="merge-listing-documents"
                                    />{' '}
                                    Listing Documents{' '}
                                    <StyledNewPill count="New" size="small" />
                                  </label>
                                </div>
                              )}
                              {oldListing.status !== 'MLS' &&
                                newListing.status === 'MLS' && (
                                  <div className="checkbox">
                                    <label className="text-danger text-uppercase">
                                      <input
                                        type="checkbox"
                                        checked={deleteOldListing}
                                        onChange={this.handleChecked(
                                          'deleteOldListing',
                                        )}
                                        data-cy="delete-old-listing"
                                      />{' '}
                                      <strong>
                                        Delete Old Listing After Merge
                                      </strong>
                                    </label>
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-default" data-dismiss="modal">
                        Cancel
                      </button>
                      {shouldCombine && canCombine && (
                        <button
                          className="btn btn-info"
                          onClick={this.mergeDetails}
                        >
                          Combine listings
                        </button>
                      )}
                      {!shouldCombine && (
                        <button
                          className="btn btn-success"
                          onClick={this.mergeDetails}
                          data-cy="merge-details-submit"
                        >
                          Merge Details
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ListingLabelContextProvider>
    );
  }
}

export default MergeListing;

const StyledNewPill = styled(Badge)`
  && {
    font-size: 12px;
  }
`;
